import { keyframes, styled } from "@mui/material/styles";
import { createSvgIcon } from "@mui/material/utils";

const LoaderIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
  >
    <g transform="translate(27,27)">
      <circle
        id="pulse"
        cx="0"
        cy="0"
        r="17"
        fill="none"
        stroke="#3B98D4"
        strokeOpacity="0.5"
        strokeWidth="6"
      />
      <circle id="core" cx="0" cy="0" r="6" fill="#3B98D4" />
    </g>
  </svg>,
  "Loader"
);

const pulse1 = keyframes`
  from {
    transform: scale(1);
  }

  8.68% {
    transform: scale(1);
  }

  39% {
    transform: scale(1.666);
  }

  47.78% {
    transform: scale(1.666);
  }

  65.16% {
    transform: scale(1);
  }

  to {
    transform: scale(1);
  }
`;

const pulse2 = keyframes`
  from {
    opacity: 0;
  }

  47.78% {
    transform: scale(0.23);
    opacity: 0;
  }

  65.16% {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(1.4);
    opacity: 0;
  }
`;

const LoaderDiv = styled("div")({
  display: "block",
  width: "54px",
  height: "54px",
  position: "absolute",
  top: "calc(50% - 27px)",
  left: "calc(50% - 27px)",

  "& > svg": {
    width: "54px",
    height: "54px",
  },

  "& #core": {
    animation: `${pulse1} 1151ms ease-out infinite`,
  },
  "& #pulse": {
    animation: `${pulse2} 1151ms ease-out infinite`,
  },
});

const Loader = () => (
  <LoaderDiv>
    <LoaderIcon />
  </LoaderDiv>
);

export default Loader;
